import { ListItemButton } from "@mui/material";
import styled, { css } from "styled-components";

interface ISelectedProps {
  $isSelected: boolean;
  $isDisabled?: boolean;
}

export const Container = styled.nav`
  padding: 2px 4px 8px;
  display: flex;
  flex-direction: column;
  width: 100%;

  a {
    display: block;
    text-decoration: none !important;
    color: inherit;
  }

  a,
  a:hover,
  a:focus-visible {
    transform: none !important;
    backface-visibility: visible;
    transition: background-color 0.15s ease, color 0.15s ease;
  }
`;

export const Menu = styled.div`
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
`;

export const MenuSectionDivider = styled.div`
  height: 1px;
  margin: 8px 10px;
  background-color: #e5e7eb;
  flex-shrink: 0;

  html.dark & {
    background-color: #262626;
  }
`;

export const MenuSectionLabel = styled.div`
  margin: 10px 12px 4px;
  padding: 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #9ca3af;
  line-height: 1.2;
  user-select: none;

  html.dark & {
    color: #6b7280;
  }
`;

export const MenuItem = styled(ListItemButton)<ISelectedProps>`
  && {
    position: relative;
    margin-bottom: 0;
    padding: 6px 12px 6px 14px !important;
    min-height: 34px !important;
    font-weight: 500;
    font-size: 0.875rem;
    border-radius: 8px !important;
    transition: background-color 0.15s ease, color 0.15s ease;
    background-color: transparent !important;
    color: #6b7280;
  }

  html.dark && {
    color: #9ca3af;
    background-color: transparent !important;
  }

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 16px;
    border-radius: 0 2px 2px 0;
    background: transparent;
    transition: background-color 0.15s ease;
  }

  /* Default icon tone — must come before selected/hover so overrides win */
  && .MuiListItemIcon-root {
    color: inherit;
    min-width: 28px;
  }

  && svg {
    color: inherit;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }

  ${(props) =>
    props.$isDisabled
      ? css`
          && {
            opacity: 0.65;
            cursor: not-allowed;
            pointer-events: none;
            color: #9ca3af !important;
            background-color: transparent !important;
          }

          && svg {
            color: #9ca3af !important;
          }
        `
      : props.$isSelected
        ? css`
            && {
              background: var(--valut-gold-gradient-tint, rgba(0, 0, 0, 0.06)) !important;
              color: #242424 !important;
              font-weight: 600;
            }

            html.dark && {
              background: var(--valut-gold-gradient-tint, rgba(255, 255, 255, 0.06)) !important;
              color: #f3f4f6 !important;
            }

            &::before {
              background: var(--valut-gold-gradient, #000000);
            }

            && svg,
            && .MuiListItemIcon-root {
              color: var(--valut-gold-accent, #000000) !important;
            }

            html.dark && svg,
            html.dark && .MuiListItemIcon-root {
              color: var(--valut-gold-accent, #ffffff) !important;
            }

            html[data-partner-brand="true"] && svg,
            html[data-partner-brand="true"] && .MuiListItemIcon-root {
              color: var(--partner-primary, #000000) !important;
            }
          `
        : css`
            &&:hover {
              color: #242424;
              background: #f9fafb !important;
            }

            html.dark &&:hover {
              color: #e5e7eb;
              background: rgba(255, 255, 255, 0.05) !important;
            }

            &&:hover svg {
              color: #374151;
            }

            html.dark &&:hover svg {
              color: #d1d5db;
            }
          `}
`;
